import { Box, Stack, Typography } from '@mui/material';
import { ReactComponent as EmptyBoxIcon } from '@src/assets/icons/empty-box.svg';

interface Props {
  title: string;
}

function EmptyState({ title }: Props) {
  return (
    <Stack alignItems="center" mt={3} mb={3}>
      <Box
        sx={{
          width: 120,
          height: 120,
          borderRadius: '50%',
          backgroundColor: '#E9F4FE',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 0.5,
        }}>
        <EmptyBoxIcon />
      </Box>

      <Typography
        variant="h6"
        sx={(theme) => ({
          color: theme.palette.text.secondary,
        })}>
        {title}
      </Typography>
    </Stack>
  );
}

export default EmptyState;
